export default "__VITE_ASSET__C4GN5yFy__"